import { z } from "zod";

import { MIN_PHONE_DIGITS } from "../../../constants/constants";

export const phoneValueSchema = z
  .string()
  .refine(
    (val) => val === "" || /^\d+$/.test(val),
    "Only numbers are allowed",
  )
  .refine(
    (val) => val === "" || val.length >= MIN_PHONE_DIGITS,
    "Phone number must be at least 7 digits",
  );

export const phoneFieldSchema = phoneValueSchema.optional();
